import axios from "axios";

// 동기 로직
export default {
  // New Method
  setTreeGridApi(state, data) {
    state.ofcTree.gridOptions = data;
  },
  setTreecode(state) {
    var reqBody = {
      userid: state.userInfo.id,
      auth: state.userInfo.auth,
    };
    var rowData = [];
    rowData.push();
    axios.post("/comn/getTree", reqBody).then((res) => {
      if (res.data.resultyn === "Y") {
        var treeData = res.data.treedata;
        for (let i = 0; i < treeData.length; i++) {
          rowData.push({
            treecode: [treeData[i].pname, treeData[i].gname, treeData[i].sname],
            code: treeData[i].stid,
          });
        }
        state.ofcTree.gridOptions.api.setRowData(rowData);
      } else {
        console.error(res.data.errormsg);
      }
    });
  },
  setUserInfo(state, user) {
    if (user === undefined || user === null) {
      state.userInfo.loginYn = false;
      state.userInfo.id = null;
      state.userInfo.name = null;
      state.userInfo.auth = null;
    } else {
      state.userInfo.loginYn = user.loginYn;
      state.userInfo.id = user.id;
      state.userInfo.name = user.name;
      state.userInfo.auth = user.auth;
    }
  },
  setWebSocket(state, param) {
    state.webSocket = param;
  },
  messageHandler(state, message) {
    // if (state.routerInfo.curPath === '/dtsManage') {
    //   state.centerBus.$emit('setDtsRealTimeData', message.data)
    // } else if (state.routerInfo.curPath === '/fbgManage') {
    //   state.centerBus.$emit('setFbgRealTimeData', message.data)
    // } else if (state.routerInfo.curPath === '/tunnelLayout') {
    //   state.centerBus.$emit('setSensorRealTimeData', message.data)
    // }
  },
  // Old Method
  userId(state, userId) {
    state.userId = userId;
  },
  userName(state, userName) {
    state.userName = userName;
  },
  isAuth(state, isAuth) {
    state.isAuth = isAuth;
  },
  sidebarOpen(state, openAt) {
    state.sidebar = openAt;
  },
  setErrorCnt(state, errorCnt) {
    state.userInfo.errorCnt = errorCnt;
  },
  setOfcTreeSelectedData(state, data) {
    if (
      data.treeDataType === "office" ||
      data.treeDataType === "status" ||
      data.treeDataType === "facStatus"
    ) {
      state.ofcTree.selectedData = {
        region: data.region,
        ofcNm: data.ofcNm,
        grpNm: data.grpNm,
        sysNm: data.sysNm,
        level: data.level,
        delYn: data.delYn,
      };
    } else if (
      data.treeDataType === "serviceOrder" ||
      data.treeDataType === "soStatus"
    ) {
      state.ofcTree.selectedData = {
        region: data.region,
        customerNm: data.customerNm,
        level: data.level,
        delYn: data.delYn,
      };
    }
  },
  setPageMoveParams(state, param) {
    state.pageMoveParams = param;
  },
  setCurrentPath(state, url) {
    state.routerInfo.curPath = url;
  },
  setUserPageAuth(state, param) {
    var pageName = state.routerInfo.curPath.substring(1);
    switch (pageName) {
      // 종합 관제
      case "dashboard":
        // 조회용 권한 불필요
        break;
      case "alarmTotStatus":
        // 조회용 권한 불필요(쿼리 자체 권한 적용)
        break;
      case "ttTotStatus":
        // 조회용 권한 불필요(쿼리 자체 권한 적용)
        break;
      case "totalAlarmFacility":
        // 조회용 권한 불필요(쿼리 자체 권한 적용)
        break;
      case "totalAlarmCustomer":
        // 조회용 권한 불필요(쿼리 자체 권한 적용)
        break;
      case "customerStatus":
        // 조회용 권한 불필요(쿼리 자체 권한 적용)
        break;
      case "platformControl":
        // 조회용 권한 불필요(쿼리 자체 권한 적용)
        break;
      case "totalVocStatus":
        // 조회용 권한 불필요(쿼리 자체 권한 적용)
        break;
      case "totalSOStatus":
        // 조회용 권한 불필요(쿼리 자체 권한 적용)
        break;
      // 시설 관리
      case "facilityStatus":
        // 조회용 권한 불필요(쿼리 자체 권한 적용)
        break;
      case "deviceConfig":
        switch (state.userInfo.authority) {
          case "SA":
          case "EO":
          case "EM":
          case "EV":
          case "EP":
            state.userPageAuth.read = false;
            state.userPageAuth.write = false;
            state.userPageAuth.partWrite = false;
            break;
          case "OC":
            state.userPageAuth.read = false;
            state.userPageAuth.write = false;
            state.userPageAuth.partWrite = true;
            break;
          default:
            state.userPageAuth.read = true;
            state.userPageAuth.write = true;
            state.userPageAuth.partWrite = true;
            break;
        }
        break;
      case "sensorManage":
        switch (state.userInfo.authority) {
          case "OC":
          case "SA":
          case "EM":
          case "EV":
          case "EP":
            state.userPageAuth.read = false;
            state.userPageAuth.write = false;
            state.userPageAuth.partWrite = false;
            break;
          default:
            state.userPageAuth.read = true;
            state.userPageAuth.write = true;
            state.userPageAuth.partWrite = true;
            break;
        }
        break;
      case "wirelessManage":
        switch (state.userInfo.authority) {
          case "OC":
          case "SA":
          case "EO":
          case "EV":
          case "EP":
            state.userPageAuth.read = false;
            state.userPageAuth.write = false;
            state.userPageAuth.partWrite = false;
            break;
          default:
            state.userPageAuth.read = true;
            state.userPageAuth.write = true;
            state.userPageAuth.partWrite = true;
            break;
        }
        break;
      case "catalogManage":
        switch (state.userInfo.authority) {
          case "OC":
          case "SA":
          case "EV":
          case "EP":
            state.userPageAuth.read = false;
            state.userPageAuth.write = false;
            state.userPageAuth.partWrite = false;
            break;
          case "EO":
          case "EM":
            state.userPageAuth.read = false;
            state.userPageAuth.write = false;
            state.userPageAuth.partWrite = true;
            break;
          default:
            state.userPageAuth.read = true;
            state.userPageAuth.write = true;
            state.userPageAuth.partWrite = true;
            break;
        }
        break;
      // 장애 관리
      case "customerAlarm":
        switch (state.userInfo.authority) {
          case "OC":
          case "EO":
          case "EM":
            state.userPageAuth.read = false;
            state.userPageAuth.write = false;
            state.userPageAuth.partWrite = true;
            break;
          case "SA":
          case "EV":
          case "EP":
            state.userPageAuth.read = false;
            state.userPageAuth.write = false;
            state.userPageAuth.partWrite = false;
            break;
          default:
            state.userPageAuth.read = true;
            state.userPageAuth.write = true;
            state.userPageAuth.partWrite = true;
            break;
        }
        break;
      case "deviceAlarm":
        switch (state.userInfo.authority) {
          case "OC":
          case "EO":
          case "EM":
            state.userPageAuth.read = false;
            state.userPageAuth.write = false;
            state.userPageAuth.partWrite = true;
            break;
          case "SA":
          case "EV":
          case "EP":
            state.userPageAuth.read = false;
            state.userPageAuth.write = false;
            state.userPageAuth.partWrite = false;
            break;
          default:
            state.userPageAuth.read = true;
            state.userPageAuth.write = true;
            state.userPageAuth.partWrite = true;
            break;
        }
        break;
      case "alarmManageStatus":
        // 조회용 권한 불필요(쿼리 자체 권한 적용)
        break;
      case "ttStatus":
        // 조회용 권한 불필요(쿼리 자체 권한 적용)
        break;
      case "alarmManageFacility":
        // 조회용 권한 불필요(쿼리 자체 권한 적용)
        break;
      case "manageAlarmCustomer":
        // 조회용 권한 불필요(쿼리 자체 권한 적용)
        break;
      // 청약 / VOC
      case "serviceOrder":
        switch (state.userInfo.authority) {
          case "EO":
          case "EM":
            state.userPageAuth.read = false;
            state.userPageAuth.write = false;
            state.userPageAuth.partWrite = true;
            break;
          case "OC":
          case "EV":
          case "EP":
            state.userPageAuth.read = false;
            state.userPageAuth.write = false;
            state.userPageAuth.partWrite = false;
            break;
          default:
            state.userPageAuth.read = true;
            state.userPageAuth.write = true;
            state.userPageAuth.partWrite = true;
            break;
        }
        break;
      case "vocManage":
        switch (state.userInfo.authority) {
          case "EO":
          case "EM":
          case "OC":
          case "EP":
            state.userPageAuth.read = false;
            state.userPageAuth.write = false;
            state.userPageAuth.partWrite = true;
            break;
          default:
            state.userPageAuth.read = true;
            state.userPageAuth.write = true;
            state.userPageAuth.partWrite = true;
            break;
        }
        break;
      // 통계
      case "facilityStatistic":
        break;
      case "alarmStatistic":
        break;
      // 플랫폼 관리
      case "userManage":
        break;
      case "ioTMakersManage":
        break;
      case "myPage":
        break;
      case "notice":
        switch (state.userInfo.authority) {
          case "AD":
          case "ED":
            state.userPageAuth.read = true;
            state.userPageAuth.write = true;
            state.userPageAuth.partWrite = true;
            break;
          default:
            state.userPageAuth.read = true;
            state.userPageAuth.write = false;
            state.userPageAuth.partWrite = false;
            break;
        }
        break;
      case "noticeForm":
        switch (state.userInfo.authority) {
          case "AD":
          case "ED":
            state.userPageAuth.read = true;
            state.userPageAuth.write = true;
            state.userPageAuth.partWrite = true;
            break;
          default:
            state.userPageAuth.read = true;
            state.userPageAuth.write = false;
            state.userPageAuth.partWrite = false;
            break;
        }
        break;
      case "gwPolicyManage":
        switch (state.userInfo.authority) {
          case "AD":
          case "ED":
            state.userPageAuth.read = true;
            state.userPageAuth.write = true;
            state.userPageAuth.partWrite = true;
            break;
          default:
            state.userPageAuth.read = true;
            state.userPageAuth.write = false;
            state.userPageAuth.partWrite = false;
            break;
        }
        break;
    }
  },
  setAlertTitle(state, param) {
    if (param === undefined || param === null) {
      state.alertOptions.title = "알림";
    } else {
      state.alertOptions.title = param;
    }
  },
  setConfirmTitle(state, param) {
    if (param === undefined || param === null) {
      state.confirmOptions.title = "확인";
    } else {
      state.confirmOptions.title = param;
    }
  },
  setWindowHeight(state, param) {
    state.windowsize.height = param;
  },
  setWindowWidth(state, param) {
    state.windowsize.width = param;
  },
  setSelectedDataProjectid(state, projectid) {
    state.selectedData.projectid = projectid;
  },
  setSelectedDataStid(state, stid) {
    state.selectedData.stid = stid;
  },
  setSelectedDataStartDate(state, startDate) {
    state.selectedData.startDate = startDate;
  },
  setSelectedDataEndDate(state, endDate) {
    state.selectedData.endDate = endDate;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/mutations.js